import { useParams, useRoutes } from "react-router-dom";

import InvoiceClonePage from "./clone";
import InvoiceEditPage from "./edit";
import InvoiceItemsPage from "./items";
import InvoicePage from "./list";
import InvoiceViewPage from "./view";

export default () =>
  useRoutes([
    { path: "/:invoiceId/items", element: <WithParameters component={InvoiceItemsPage}/> },
    { path: "/:invoiceId/clone", element: <WithParameters component={InvoiceClonePage}/> },
    { path: "/:invoiceId/edit", element: <WithParameters component={InvoiceEditPage}/> },
    { path: "/:invoiceId", element: <WithParameters component={InvoiceViewPage}/> },
    { path: "/", element: <WithParameters component={InvoicePage}/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
